/* np-latch:start */
// Nikita 2026-07-28: «повертаєшся з чекауту — на кнопці анімація завантаження, і вона не
// клікається». The checkout CTA is guarded by a busy latch so a double-click cannot fire
// two checkouts, but that latch was ONE-WAY: set on click, cleared only by an error path.
// Every way of coming BACK to a page that still holds it (bfcache restore, browser Back,
// a navigation the browser cancels) brings the page back WITH the latch held — the button
// keeps the progress cursor and swallows every click. Two escape hatches, both required:
//   pagehide/pageshow -> a page that comes back always comes back released;
//   a watchdog        -> a navigation that never lands frees the CTA instead of parking it.
// Covered by tooling/np_checkout_latch_test.js — keep the markers, the test slices on them.
function npCheckoutLatch(button, options) {
  var opts = options || {};
  var win = opts.window || window;
  var timeoutMs = opts.timeoutMs || 8000;
  var busy = false;
  var timer = null;
  function release() {
    busy = false;
    if (timer !== null) { clearTimeout(timer); timer = null; }
    if (button && button.classList) button.classList.remove('is-submitting');
  }
  function acquire() {
    if (busy) return false;
    busy = true;
    if (button && button.classList) button.classList.add('is-submitting');
    timer = setTimeout(release, timeoutMs);
    return true;
  }
  win.addEventListener('pagehide', release);
  win.addEventListener('pageshow', release);
  return { acquire: acquire, release: release, isBusy: function () { return busy; } };
}
/* np-latch:end */

function NovaPoshtaMain() {
  const apiKey            = NP_API_KEY;
  const endpointNP        = 'https://api.novaposhta.ua/v2.0/json/'; // https: an http:// fetch from the https page rides on CSP upgrade (or blocks) — never ship mixed content
  const country           = 'Ukraine';
  const provider          = 'Нова пошта';
  const quickIndices      = quickCityIndices.split(' ');
  const bodyNP            = document.getElementById('nova-poshta');
  const deliveryVariants  = document.getElementById('deliveryVariants');

  const deliveryTypes     = document.querySelectorAll('input[type="radio"][name="id"]');
  let deliveryType        = deliveryTypes[0].getAttribute('data-type');
  let isDelivery          = false;
  // Wraps
  const wrapWarehouse     = document.querySelector('.warehouse-wrap');
  const wrapAddresses     = document.querySelector('.address-wrap');
  // Inputs
  const inputCity         = document.getElementById('city-search');
  const inputWarehouse    = document.getElementById('warehouse-search');
  const inputStreet       = document.getElementById('address-street');
  const inputBuild        = document.getElementById('address-build');
  const inputFlat         = document.getElementById('address-flat');
  const inputFields       = document.querySelectorAll('.form-group input');
  const filterFields      = document.querySelectorAll('.dropdown-filter');

  const buttonShipping    = document.querySelector('[data-name="shipping"]');  
  const cartDraver        = document.querySelector('.qsc2-drawer');
  const cityErrorEl       = document.querySelector('.city-wrap .input-error'); 
  const warehouseErrorEl  = document.querySelector('.warehouse-wrap .input-error');
  const streetErrorEl     = document.querySelector('.address-wrap .input-error');
  const clearCity         = document.querySelector(".city-wrap .clear");
  const clearWarehouse    = document.querySelector(".warehouse-wrap .clear");
  const clearStreet       = document.querySelector(".form-street .clear");
  const cartUrl           = deliveryVariants.getAttribute('data-carturl');
  const properties        = {_provider: provider, _country: country};

  // DigX fix (CART-1): never surface a raw fetch/JSON error to the shopper as a
  // browser alert(). A failed /cart/update.js write (e.g. an HTML Cloudflare
  // challenge instead of JSON) used to hit `.catch(npSilent)` and pop the scary
  // "SyntaxError: Unexpected token '<', '<!DOCTYPE'..." dialog. Log quietly instead.
  function npSilent(e){ try { console.warn('[NovaPoshta] delivery write failed:', (e && e.message) || e); } catch(_) {} }

  let dataCities, dataWarehouses, dataStreet, addressCity, addressZip, addressStreet, addressBuild, addressFlat, cityData, warehouseData;
  wrapWarehouse.classList.add('d-none');
  wrapAddresses.classList.add('d-none');
  // Nikita 2026-07-27: the drawer's checkout CTA must NEVER be a disabled button — it stays the
  // working green button, and while no delivery is chosen the click routes to the Доставка
  // screen (the way Control behaves). The drawer already owns that gate: digx-cart.js marks the
  // root `.digx-cart--no-delivery` and a CAPTURE-phase click on `.checkout-button-wrap` opens the
  // sheet before this file's own handler can run. A real `disabled` attribute would break that,
  // because the browser dispatches no click at all from a disabled control.
  // So NP's own disable is confined to the /cart page, which has no drawer gate of its own.
  // The test is DOM ownership, not `pageType`: verified 2026-07-27 that the drawer's own NP
  // instance reports pageType === 'cart', so keying off pageType silently disabled the drawer CTA.
  var npOwnsGate = !(checkoutButton && checkoutButton.closest && checkoutButton.closest('.digx-cart'));
  function npGateCheckout() {
    if (!npOwnsGate) return;
    checkoutButton.classList.add('disabled');
    checkoutButtonWrapper.classList.add('tool');
    checkoutButton.disabled = true;
  }
  npGateCheckout();
  /*== shipping notifications ==*/
  function btnHover() {  
    checkoutButtonWrapper.addEventListener("mouseover", (event) => {
      if(checkoutButtonWrapper.classList.contains('tool')) {
        buttonShipping.classList.add('button-hover');
      }
    })
    checkoutButtonWrapper.addEventListener("mouseout", (event) => {        
      if(checkoutButtonWrapper.classList.contains('tool')) {
        buttonShipping.classList.remove('button-hover');
      }
    })
  }
  /*== update cart note  ==*/
  async function updateCartNote() {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({note: "null"}),
        credentials: 'same-origin',
        cache: 'no-cache',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.json();
    } catch (error) {
      throw error;
    }
  }
  if(pageType == 'sidebar') btnHover();

  /*== Error API ==*/
  function errorAPI() {
    document.querySelector('.checkout-button-wrap').classList.remove('tool');
    console.log('error');
    /*== check selected delivery type ==*/
    fetch(`${cartUrl}.json`).then(response => response.json()).then(data => {

      wrapWarehouse.classList.add('d-none');    
      wrapAddresses.classList.add('d-none');
      //alert('1');

      if (data.attributes._delivery_type) {
        isDelivery = true;
        deliveryVariants.setAttribute('data-variant', data.attributes._delivery_type);
        if(cartDraver) cartDraver.setAttribute('data-delivery', data.attributes._delivery_type);
        document.querySelector('input[type="radio"][name="id"][data-type='+data.attributes._delivery_type+']').checked=true;
        deliveryType = data.attributes._delivery_type;
        
        if(deliveryType == 'courier') {

          filterExclusion = '-1';
          wrapAddresses.classList.remove('d-none');
          properties._delivery_method  = methodCourier;
          checkoutButton.disabled = false;
          checkoutButtonWrapper.classList.remove('tool');
          if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = methodCourier;

        } else {

          filterExclusion = '0';
          wrapWarehouse.classList.remove('d-none');
          properties._delivery_type = deliveryType;
          properties._delivery_method = methodBranch;

        }
      }    
      if (!isDelivery) {
        if(cartDraver) cartDraver.setAttribute('data-delivery', deliveryType);
        wrapWarehouse.classList.remove('d-none');
        properties._delivery_type = deliveryType;
        properties._delivery_method = methodBranch;        
        filterExclusion = '0';     
      }
      
      // DigX fix (Roman 2026-07-24): the original app nulled every saved delivery
      // detail on init and wrote the wipe back to the cart, so returning from the
      // checkout lost the chosen city/branch (the "Доставка" text lingered but the
      // fields + checkout gate were empty until re-selecting). Restore the saved
      // selection from cart attributes instead of wiping it.
      var savedAttrs = data.attributes || {};
      var hasSavedDelivery = savedAttrs._delivery_warehouse_Number
        || savedAttrs._delivery_warehouse
        || savedAttrs._delivery_street
        || savedAttrs._delivery_courier_address;

      if (hasSavedDelivery) {
        // preserve every saved _delivery_* value (keeps the cart + checkout intact)
        Object.keys(savedAttrs).forEach(function (k) {
          if (k.indexOf('_delivery_') === 0) properties[k] = savedAttrs[k];
        });
        // repaint the picker fields so the shopper sees their saved choice
        if (inputCity && savedAttrs._delivery_city) inputCity.value = savedAttrs._delivery_city;
        if (deliveryType == 'courier') {
          if (inputStreet && savedAttrs._delivery_street) inputStreet.value = savedAttrs._delivery_street;
          if (inputBuild && savedAttrs._delivery_house) inputBuild.value = savedAttrs._delivery_house;
          if (inputFlat && savedAttrs._delivery_flat) inputFlat.value = savedAttrs._delivery_flat;
        } else if (inputWarehouse && (savedAttrs._delivery_warehouse || savedAttrs._delivery_warehouse_address)) {
          inputWarehouse.value = savedAttrs._delivery_warehouse || savedAttrs._delivery_warehouse_address;
          inputWarehouse.readOnly = true;
        }
        // a valid delivery is already chosen -> un-gate checkout
        checkoutButton.classList.remove('disabled');
        checkoutButtonWrapper.classList.remove('tool');
        checkoutButton.disabled = false;
        updateCartDeliveryAttr(properties).catch(npSilent);
      } else {
        // no prior selection -> original fresh-state behaviour (null the details)
        properties._delivery_courier_address              = null;
        properties._delivery_street                       = null;
        properties._delivery_house                        = null;
        properties._delivery_flat                         = null;
        properties._delivery_street_Ref                   = null;
        properties._delivery_city                         = null;
        properties._delivery_city_Area                    = null;
        properties._delivery_city_Ref                     = null;
        properties._delivery_warehouse                    = null;
        properties._delivery_warehouse_zip                = null;
        properties._delivery_warehouse_name               = null;
        properties._delivery_warehouse_address            = null;
        properties._delivery_warehouse_CityRef            = null;
        properties._delivery_warehouse_Number             = null;
        properties._delivery_warehouse_Ref                = null;
        properties._delivery_warehouse_SettlementRef      = null;
        properties._delivery_warehouse_TypeOfWarehouse    = null;
        updateCartDeliveryAttr(properties);
      }
      
    
        //updateCartNote();

    }) 
    /*== check changes delivery type ==*/
    deliveryTypes.forEach(function(el){
      el.addEventListener("change", function(){
        deliveryType = this.getAttribute('data-type');
        wrapWarehouse.classList.add('d-none');    
        wrapAddresses.classList.add('d-none');
        inputFields.forEach(function(e){ e.value = '';})
        cityErrorEl.innerHTML = '';
        warehouseErrorEl.innerHTML = '';
        streetErrorEl.innerHTML = '';
        

        properties._delivery_type = deliveryType;
        if(cartDraver) cartDraver.setAttribute('data-delivery', deliveryType);
        if (deliveryType == 'branch') {
          properties._delivery_method = methodBranch;
          wrapWarehouse.classList.remove('d-none');
          if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = titleDelivery;
        } else {
          properties._delivery_method = methodCourier;
          wrapAddresses.classList.remove('d-none');
          checkoutButton.classList.remove('disabled');
          checkoutButton.disabled = false;
          if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = methodCourier;
        }
        properties._delivery_courier_address              = null;
        properties._delivery_street                       = null;
        properties._delivery_house                        = null;
        properties._delivery_flat                         = null;
        properties._delivery_street_Ref                   = null;
        properties._delivery_city                         = null;
        properties._delivery_city_Area                    = null;
        properties._delivery_city_Ref                     = null;
        properties._delivery_warehouse                    = null;
        properties._delivery_warehouse_zip                = null;
        properties._delivery_warehouse_name               = null;
        properties._delivery_warehouse_address            = null;
        properties._delivery_warehouse_CityRef            = null;
        properties._delivery_warehouse_Number             = null;
        properties._delivery_warehouse_Ref                = null;
        properties._delivery_warehouse_SettlementRef      = null;
        properties._delivery_warehouse_TypeOfWarehouse    = null;
        updateCartDeliveryAttr(properties).then(function() {/*console.log(cart)*/}).catch(npSilent);     
      })
    })
    /*== update cart attribute  ==*/
    async function updateCartDeliveryAttr(data) {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({ attributes: data}),
        credentials: 'same-origin',
        cache: 'no-cache',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.json();
    } catch (error) {
      throw error;
    }
    }
    // same no-dead-CTA contract as the main path below (Roman 2026-07-27): a busy latch
    // instead of disabling the button, so a failed fetch can never brick the checkout.
    var fallbackLatch = npCheckoutLatch(checkoutButton);
    checkoutButton.addEventListener('click', async function(e) {

      e.preventDefault();
      if (!fallbackLatch.acquire()) return;


      addressStreet = addressCity = addressWarehouse = false;
      if(inputStreet.value) addressStreet = 'вул.'+inputStreet.value; //(addressStreet)?addressStreet:'';
      if(inputBuild.value) addressStreet = addressStreet +' буд.'+inputBuild.value;
      if(inputFlat.value) addressStreet = addressStreet +' кв.'+inputFlat.value;
      if(inputCity.value) addressCity = inputCity.value; //(addressCity)?addressCity:'';
      if(inputWarehouse.value) addressWarehouse = inputWarehouse.value;      
      addressZip = '12345';

      properties._delivery_courier_address              = (addressStreet != false ) ? addressStreet : null;
      properties._delivery_city                         = (addressCity != false ) ? addressCity : null;
      properties._delivery_warehouse_zip                = addressZip;
      properties._delivery_warehouse_Number             = (addressWarehouse != false ) ? addressWarehouse : null;

      updateCartDeliveryAttr(properties);   

      let addr_delivery_courier_address              = (addressStreet != false ) ? addressStreet : '';
      let addr_delivery_city                         = (addressCity != false ) ? addressCity : '';
      let addr_delivery_warehouse_Number             = (addressWarehouse != false ) ? addressWarehouse : '';

      const address = ({
        address1: (deliveryType == 'branch') ? 'відділення/поштомат '+addr_delivery_warehouse_Number : addr_delivery_courier_address+' ('+methodCourier+')',
        zip: addressZip, 
        city: addr_delivery_city,
        country: country
      });
      
      setTimeout( function() {
      fetch(`${cartUrl}.json`).then(response => response.json()).then(data => {
          const pairs = [];
          
          const path = data.items.map(item => {
            return `${item.variant_id}:${item.quantity}`;
          }).join(',');

          for (var key in properties) {
            const value = properties[key];

            if (!value) continue;

            const pair = `attributes[${key}]=${properties[key]}`;

            pairs.push(pair);
          }

          for (var key in address) {
            const value = address[key];

            if (!value) continue;

            const pair = `checkout[shipping_address][${key}]=${address[key]}`;

            pairs.push(pair);
          }

          let query;
          let url;
          if (data.note && data.note != null) {
          query = pairs.join('&') + `&note=${data.note}`;
          url = `${cartUrl}/${path}?${query}`;
          } else {
          query = pairs.join('&');  
          url = `${cartUrl}/${path}?${query}`;
          }


          window.location.href = url;

        }).catch(function (err) {
          npSilent(err);
          fallbackLatch.release();
          window.location.href = cartUrl;
        });
      },200);

    });
  }

  /*== Request API ==*/
  async function reqAPI(data) {

    console.log('data-',JSON.stringify(data)); 
    
    try {
      const response = await fetch(endpointNP, {
        method: 'POST',
        body: JSON.stringify(data),
        credentials: 'same-origin',
        cache: 'no-cache',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.json();      
    } 
    catch (error) {
      //throw error;
      console.log('error');
      console.log('data-',JSON.stringify(data)); 
       
    }
  } 

// DigX (2026-07, Sasha round 3): the widget used to gate ALL of its wiring behind an
// "is NP alive" probe request — +0.3-1s of dead time on every drawer open, and a dead
// widget whenever NP hiccuped. Init immediately; every real search handles NP failure.
Promise.resolve({success: true})
.then(res => {

  if (res.success) {

    /*== check selected delivery type ==*/
    fetch(`${cartUrl}.json`).then(response => response.json()).then(data => {

      wrapWarehouse.classList.add('d-none');    
      wrapAddresses.classList.add('d-none');
      //alert('1');

      if (data.attributes._delivery_type) {
        isDelivery = true;
        deliveryVariants.setAttribute('data-variant', data.attributes._delivery_type);
        if(cartDraver) cartDraver.setAttribute('data-delivery', data.attributes._delivery_type);
        document.querySelector('input[type="radio"][name="id"][data-type='+data.attributes._delivery_type+']').checked=true;
        deliveryType = data.attributes._delivery_type;
        
        if(deliveryType == 'courier') {

          filterExclusion = '-1';
          wrapAddresses.classList.remove('d-none');
          properties._delivery_method  = methodCourier;
          checkoutButton.disabled = false;
          checkoutButtonWrapper.classList.remove('tool');
          if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = methodCourier;

        } else {

          filterExclusion = '0';
          wrapWarehouse.classList.remove('d-none');
          properties._delivery_type = deliveryType;
          properties._delivery_method = methodBranch;

        }
      }    
      if (!isDelivery) {
        if(cartDraver) cartDraver.setAttribute('data-delivery', deliveryType);
        wrapWarehouse.classList.remove('d-none');
        properties._delivery_type = deliveryType;
        properties._delivery_method = methodBranch;        
        filterExclusion = '0';     
      }
      
      // DigX fix (Roman 2026-07-24): the original app nulled every saved delivery
      // detail on init and wrote the wipe back to the cart, so returning from the
      // checkout lost the chosen city/branch (the "Доставка" text lingered but the
      // fields + checkout gate were empty until re-selecting). Restore the saved
      // selection from cart attributes instead of wiping it.
      var savedAttrs = data.attributes || {};
      var hasSavedDelivery = savedAttrs._delivery_warehouse_Number
        || savedAttrs._delivery_warehouse
        || savedAttrs._delivery_street
        || savedAttrs._delivery_courier_address;

      if (hasSavedDelivery) {
        // preserve every saved _delivery_* value (keeps the cart + checkout intact)
        Object.keys(savedAttrs).forEach(function (k) {
          if (k.indexOf('_delivery_') === 0) properties[k] = savedAttrs[k];
        });
        // repaint the picker fields so the shopper sees their saved choice
        if (inputCity && savedAttrs._delivery_city) inputCity.value = savedAttrs._delivery_city;
        if (deliveryType == 'courier') {
          if (inputStreet && savedAttrs._delivery_street) inputStreet.value = savedAttrs._delivery_street;
          if (inputBuild && savedAttrs._delivery_house) inputBuild.value = savedAttrs._delivery_house;
          if (inputFlat && savedAttrs._delivery_flat) inputFlat.value = savedAttrs._delivery_flat;
        } else if (inputWarehouse && (savedAttrs._delivery_warehouse || savedAttrs._delivery_warehouse_address)) {
          inputWarehouse.value = savedAttrs._delivery_warehouse || savedAttrs._delivery_warehouse_address;
          inputWarehouse.readOnly = true;
        }
        // a valid delivery is already chosen -> un-gate checkout
        checkoutButton.classList.remove('disabled');
        checkoutButtonWrapper.classList.remove('tool');
        checkoutButton.disabled = false;
        updateCartDeliveryAttr(properties).catch(npSilent);
      } else {
        // no prior selection -> original fresh-state behaviour (null the details)
        properties._delivery_courier_address              = null;
        properties._delivery_street                       = null;
        properties._delivery_house                        = null;
        properties._delivery_flat                         = null;
        properties._delivery_street_Ref                   = null;
        properties._delivery_city                         = null;
        properties._delivery_city_Area                    = null;
        properties._delivery_city_Ref                     = null;
        properties._delivery_warehouse                    = null;
        properties._delivery_warehouse_zip                = null;
        properties._delivery_warehouse_name               = null;
        properties._delivery_warehouse_address            = null;
        properties._delivery_warehouse_CityRef            = null;
        properties._delivery_warehouse_Number             = null;
        properties._delivery_warehouse_Ref                = null;
        properties._delivery_warehouse_SettlementRef      = null;
        properties._delivery_warehouse_TypeOfWarehouse    = null;
        updateCartDeliveryAttr(properties);
      }   
      
        //updateCartNote();
    }) 
    /*== check changes delivery type ==*/
    deliveryTypes.forEach(function(el){
      el.addEventListener("change", function(){
        deliveryType = this.getAttribute('data-type');
        wrapWarehouse.classList.add('d-none');    
        wrapAddresses.classList.add('d-none');
        checkoutButtonWrapper.classList.add('tool');
        inputFields.forEach(function(e){ e.value = '';})
        cityErrorEl.innerHTML = '';
        warehouseErrorEl.innerHTML = '';
        streetErrorEl.innerHTML = '';
        filterFields.forEach(function(f){ 
          while(f.firstChild){ filter.removeChild(filter.firstChild);}
        });

        properties._delivery_type = deliveryType;
        if(cartDraver) cartDraver.setAttribute('data-delivery', deliveryType);
        if (deliveryType == 'branch') {
          properties._delivery_method = methodBranch;         
          filterExclusion = '0';         
          wrapWarehouse.classList.remove('d-none');
          if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = titleDelivery;
        } else {
          properties._delivery_method = methodCourier;        
          filterExclusion = '-1';         
          wrapAddresses.classList.remove('d-none');
          checkoutButton.classList.remove('disabled');
          checkoutButtonWrapper.classList.remove('tool');
          checkoutButton.disabled = false;
          if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = methodCourier;
        }
        properties._delivery_courier_address              = null;
        properties._delivery_street                       = null;
        properties._delivery_house                        = null;
        properties._delivery_flat                         = null;
        properties._delivery_street_Ref                   = null;
        properties._delivery_city                         = null;
        properties._delivery_city_Area                    = null;
        properties._delivery_city_Ref                     = null;
        properties._delivery_warehouse                    = null;
        properties._delivery_warehouse_zip                = null;
        properties._delivery_warehouse_name               = null;
        properties._delivery_warehouse_address            = null;
        properties._delivery_warehouse_CityRef            = null;
        properties._delivery_warehouse_Number             = null;
        properties._delivery_warehouse_Ref                = null;
        properties._delivery_warehouse_SettlementRef      = null;
        properties._delivery_warehouse_TypeOfWarehouse    = null;
        updateCartDeliveryAttr(properties).then(function() {/*console.log(cart)*/}).catch(npSilent);     
      })
    })
    /*== update cart attribute  ==*/
    async function updateCartDeliveryAttr(data) {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({ attributes: data}),
        credentials: 'same-origin',
        cache: 'no-cache',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.json();
    } catch (error) {
      throw error;
    }
    }
    /*== hover on checkout button ==*/
    if(pageType == 'sidebar') {
      checkoutButton.addEventListener("mouseover", () => {    
          buttonShipping.classList.add('button-checkout-hover');
      })
      checkoutButton.addEventListener("mouseout", () => {     
          buttonShipping.classList.remove('button-checkout-hover');      
      })
    }
    /*== text input clear ==*/
    document.querySelectorAll(".clear").forEach(function(el, index){
        el.addEventListener('click', function() {
          document.querySelectorAll(".form-group input")[index].value = '';
          document.querySelectorAll(".form-group input")[index].readOnly = false;
          if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = titleDelivery;
          document.querySelectorAll(".form-group input")[index].focus();
          this.classList.add('d-none');
          if(index == 0) {
            document.querySelectorAll(".form-group").forEach(function(el) {
              el.querySelector('input').value = '';
              el.querySelector('.clear') ? el.querySelector('.clear').classList.add('d-none') : null;
              el.querySelector("input").readOnly = false;
            })
          }
          if (deliveryType == 'branch')  checkoutButtonWrapper.classList.add('tool');
          filterFields.forEach(function(f){clearList(f)});
          bodyNP.classList.remove('filter-active');
          warehouseErrorEl.innerHTML = '';
          cityErrorEl.innerHTML = ''; 
          streetErrorEl.innerHTML = '';      
      });
    })
    /*== remove filter result list ==*/
    function clearList(filter) {
      while(filter.firstChild){filter.removeChild(filter.firstChild)}
    }  
    function pointPrefix(data) {
      switch (data) {  
        case 'Postomat':
        pointType = 'Поштомат';
          break;
        case 'Branch':
        pointType = 'Відділення';
          break;      
        default:
        pointType = data;
          break;
      }
      return pointType;
    }
    function stripslashes_n(str) {
      return str.replace(/'/g,`ʹ`);
    }   
    /*== search city  ==*/
    function searchCity() { 
      let linkClass = '';        
      let filter = document.querySelector('#city_filter');        
      let dataQuickCity;
      let quickOutput = '';
      let output_prev = 0;
      
      // DigX (2026-07, Sasha round 3): quick-city refs are static — cache them for a
      // day so the drawer doesn't refire 5 NP requests on every open (instant links,
      // and the saved rate budget goes to the shopper's real searches).
      var QCK = 'digx_np_quick_v1';
      function renderQuick(item, index){
        quickOutput = `<a data-val='`+stripslashes_n(JSON.stringify(item))+`' class='quick-city-link' href='javascript:void(0)' style='display:block; order:`+index+`;'>`+ item.MainDescription + `</a>`;
        document.querySelector('.quick-city-wrap').insertAdjacentHTML('afterbegin',quickOutput);
      }
      var qCached = null;
      try { qCached = JSON.parse(localStorage.getItem(QCK) || 'null'); } catch(e) {}
      if (qCached && qCached.t && (Date.now() - qCached.t) < 86400000 && (qCached.items || []).length === quickIndices.length) {
        qCached.items.forEach(renderQuick);
      } else {
        var qCollected = [];
        quickIndices.forEach(function(qСity, index){
          reqAPI({"apiKey": apiKey,"modelName": "AddressGeneral","calledMethod": "searchSettlements","methodProperties": {"CityName" : qСity,"Limit" : "1","Page" : "1"}})
            .then(function(ress) { dataQuickCity = ress.data[0].Addresses[0];
              renderQuick(dataQuickCity, index);
              qCollected[index] = dataQuickCity;
              var done = 0; for (var qi = 0; qi < quickIndices.length; qi++) { if (qCollected[qi]) done++; }
              if (done === quickIndices.length) {
                try { localStorage.setItem(QCK, JSON.stringify({t: Date.now(), items: qCollected})); } catch(e) {}
              }
            })
              .catch(npSilent);
        })
      }


      // DigX fix (delay bug 2026-07): delegated click instead of a fixed 1500ms
      // setTimeout binding — quick-city links inserted by the API after 1.5s never
      // got a handler (dead buttons on slow connections).
      document.querySelector('.quick-city-wrap').addEventListener("click", function(ev){
        var qlink = ev.target.closest('a.quick-city-link');
        if (!qlink) return;

        clearCity.classList.remove('d-none');
        inputWarehouse.readOnly = false;
        document.querySelectorAll(".form-group").forEach(function(el){
          if (!el.classList.contains('form-city')) {
            el.querySelector('input.form-control').value = '';
            el.querySelector('.clear') ? el.querySelector('.clear').classList.add('d-none') : null;
            if (deliveryType == 'branch')  checkoutButtonWrapper.classList.add('tool');
          }
        })

        cityData = JSON.parse(qlink.getAttribute('data-val'));
        addressCity                     = cityData.MainDescription;
        inputCity.value                 = cityData.Present;
        properties._delivery_city       = cityData.Present;
        properties._delivery_city_Ref   = cityData.DeliveryCity;
        updateCartDeliveryAttr(properties).then(function(cart) {/*console.log(cart)*/}).catch(npSilent);
        clearList(filter);

        if (deliveryType == 'branch' && cityData.DeliveryCity ) {
          searchWarehouse(cityData.DeliveryCity);   // field appears INSTANTLY; warehouses search server-side per keystroke (was: 5-15MB full-city download first)
        } else if (deliveryType == 'courier' && cityData.DeliveryCity) {
          searchStreet(cityData.DeliveryCity);
        }
      })

      // DigX fix (delay bug 2026-07): pick a searched city — ONE delegated listener
      // (was: re-bound per render = stacked stale handlers).
      filter.addEventListener("click", function(ev){
        var clink = ev.target.closest('a.city-link');
        if (!clink) return;
        bodyNP.classList.remove('filter-active');
        document.querySelector('.city-wrap .input-error').innerHTML = "";
        cityData = JSON.parse(clink.getAttribute('data-val'));
        addressCity                     = cityData.Present;//передача повного міста (обл, р-н ...)
        inputCity.value                 = cityData.Present;
        properties._delivery_city       = cityData.Present;
        properties._delivery_city_Ref   = cityData.DeliveryCity;
        updateCartDeliveryAttr(properties).then(function(cart) {/*console.log(cart)*/}).catch(npSilent);
        clearList(filter)

        if (deliveryType == 'branch' && cityData.DeliveryCity ) {
          searchWarehouse(cityData.DeliveryCity);   // instant field + server-side search (was: 5-15MB full-city download first)
        } else if (deliveryType == 'courier' && cityData.DeliveryCity) {
          searchStreet(cityData.DeliveryCity);
        }
      });

      var citySeq = 0, cityTimer = null;
      inputCity.addEventListener("keyup", function(event){
        if(event.key != 'ArrowLeft' && event.key != 'ArrowRight') {
          let searchField = this.value;
          inputWarehouse.value = inputStreet.value = '';
          inputWarehouse.readOnly = false;
          document.getElementById('warehouse_filter').classList.remove('active');
          document.getElementById('street_filter').classList.remove('active');
          if (deliveryType == 'branch')  checkoutButtonWrapper.classList.add('tool');
          clearCity.classList.remove('d-none');

          if(searchField === '' || searchField === ' ' ){ clearList(filter);bodyNP.classList.remove('filter-active');cityErrorEl.innerHTML = '';clearCity.classList.add('d-none'); output_prev=0; return;}

          // DigX fix (delay bug 2026-07): render IN the response callback with a
          // stale-response guard (was: fire the request, then render whatever
          // dataCities held after a fixed 500ms — an added half-second AND a race
          // that showed the previous keystroke's results on fast typing). 250ms
          // debounce + throttle-retry keep fast typing under NP's rate limit.
          var seq = ++citySeq;
          clearTimeout(cityTimer);
          cityTimer = setTimeout(function(){
          reqAPIRetry({"apiKey": apiKey,"modelName": "AddressGeneral","calledMethod": "searchSettlements","methodProperties": {
            "CityName" : searchField,
            "Limit" : "150",
            "Page" : "1",
            "Warehouse": "1"
          }
        }, function(){ return seq !== citySeq; })
            .then(function(res) {
              if (seq !== citySeq) return;               // a newer keystroke owns the list
              dataCities = res.data[0].Addresses;
              let output = '';
              if(dataCities.length > 0) {
                clearList(filter); cityErrorEl.innerHTML = '';
                dataCities.forEach(function(val){
                  linkClass = (val.Warehouses == 0 && deliveryType == 'branch' ) ? 'd-none' : '';
                  output += `<a data-val='`+stripslashes_n(JSON.stringify(val))+`' class='city-link `+ linkClass +`' href='javascript:void(0)' style='display:block;'>`+ val.Present + `</a>`;
                });
              } else { if(output_prev>0) cityErrorEl.innerHTML = alertCity };
              filter.insertAdjacentHTML('afterbegin',output);
              if (output_prev > 0) {
                bodyNP.classList.add('filter-active');
                document.getElementById('city_filter').classList.add('active');
              }
              output_prev = output.length;
            })
              .catch( function() {console.log('error');clearList(filter); cityErrorEl.innerHTML = alertKeyboard });
          }, 250);
        }
      });
    }
    /*== search branch/postomat ==*/
    // DigX rewrite (delay bug 2026-07, "поштомат тільки через 2-5 секунд"):
    // the old flow downloaded the WHOLE city's warehouse list up-front
    // (Limit 10000 → 5.7MB / 1712 rows for Харків) and only then revealed the
    // field, then filtered client-side with per-render listener stacking.
    // Now: the field appears the moment the city is picked, and every keystroke
    // asks Nova Poshta directly (FindByString, Limit 300, 200ms debounce,
    // stale-response guard). One delegated pick handler instead of stacked ones.
    var warehouseCityRef = null, warehouseSeq = 0, warehouseTimer = null, warehouseWired = false;
    // NP throttles request bursts ("To many requests") — one spaced retry, only if
    // the keystroke that asked is still the latest (isStale re-checked both times).
    function reqAPIRetry(payload, isStale) {
      function isThrottled(res){ return res && res.success === false && String((res.errors||[])[0]||'').toLowerCase().indexOf('many requests') > -1; }
      function wait(ms){ return new Promise(function(r){ setTimeout(r, ms); }); }
      return reqAPI(payload).then(function(res){
        if (!isThrottled(res) || isStale()) return res;
        return wait(700).then(function(){ return isStale() ? res : reqAPI(payload); }).then(function(res2){
          if (!isThrottled(res2) || isStale()) return res2;
          return wait(1400).then(function(){ return isStale() ? res2 : reqAPI(payload); });
        });
      });
    }
    // Per-session cache: (cityRef|query) -> rows. Retypes, backspace-to-empty and
    // re-picked cities render from memory instead of refiring NP requests.
    var warehouseCache = {};
    function warehouseFetch(cityRef, q, isStale) {
      var key = cityRef + '|' + q;
      if (warehouseCache[key]) return Promise.resolve(warehouseCache[key]);
      return reqAPIRetry({"apiKey": apiKey,"modelName": "AddressGeneral","calledMethod": "getWarehouses","methodProperties": {
        "CityRef" : cityRef,
        "FindByString" : q,
        "Page" : "1",
        "Limit" : q === '' ? "150" : "300",
        "Language" : "UA"
      }}, isStale).then(function(res){
        var data = (res && res.data) || [];
        if (res && res.success !== false) warehouseCache[key] = data;
        return data;
      });
    }
    function renderWarehouses(filter, data) {
      var output = '';
      data.forEach(function(val){
        output += `<a data-val='`+stripslashes_n(JSON.stringify(val))+`' class='warehouse-link' href='javascript:void(0)' style='display:block;'>` + val.Description + `</a>`;
      });
      clearList(filter);
      if (output.length > 0) { warehouseErrorEl.innerHTML = ''; } else { warehouseErrorEl.innerHTML = alertWarehouse; }
      filter.insertAdjacentHTML('afterbegin', output);
      if (data.length > 0) document.getElementById('warehouse_filter').classList.add('active');
    }
    function searchWarehouse(cityRef) {
      warehouseCityRef = cityRef;
      wrapWarehouse.classList.remove('d-none');
      let filter = document.querySelector('#warehouse_filter');
      clearList(filter);
      // DigX (2026-07, Sasha round 3): prefetch the first 150 points right at city
      // pick so a browsable list is ALREADY on screen when the shopper taps the
      // field (the old UX trained people to wait for a list). Typing narrows
      // server-side across ALL of the city's points; a keystroke that lands before
      // the prefetch simply wins via the seq guard. Zero-warehouse cities still
      // keep checkout gated on branch mode (switch to courier to proceed).
      var prefetchSeq = ++warehouseSeq;
      warehouseFetch(cityRef, '', function(){ return prefetchSeq !== warehouseSeq; })
        .then(function(data){
          if (prefetchSeq !== warehouseSeq || warehouseCityRef !== cityRef) return;
          if ((inputWarehouse.value || '') !== '') return;
          renderWarehouses(filter, data);
        }).catch(npSilent);
      if (warehouseWired) return;
      warehouseWired = true;

      // pick a point (delegated once)
      filter.addEventListener("click", function(ev){
        var wlink = ev.target.closest('a.warehouse-link');
        if (!wlink) return;
        warehouseData = JSON.parse(wlink.getAttribute('data-val'));
        warehouseErrorEl.innerHTML = '';
        addressStreet = warehouseData.Description;
        inputWarehouse.value = addressStreet;
        inputWarehouse.readOnly = true;
        addressZip = warehouseData.PostalCodeUA;
        addressZip = '12345';
        addressBuild = addressFlat = '';
        clearList(filter);
        properties._delivery_warehouse                 = addressStreet;
        properties._delivery_warehouse_zip             = addressZip;
        properties._delivery_warehouse_name            = pointPrefix(warehouseData.CategoryOfWarehouse)+':'+warehouseData.Number;
        properties._delivery_warehouse_address         = warehouseData.ShortAddress;
        properties._delivery_warehouse_CityRef         = warehouseData.CityRef;
        properties._delivery_warehouse_Number          = warehouseData.Number;
        properties._delivery_warehouse_Ref             = warehouseData.Ref;
        properties._delivery_warehouse_SettlementRef   = warehouseData.SettlementRef;
        properties._delivery_warehouse_TypeOfWarehouse = warehouseData.TypeOfWarehouse;
        checkoutButton.classList.remove('disabled');
        checkoutButtonWrapper.classList.remove('tool');
        checkoutButton.disabled = false;
        if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = addressCity +', '+pointPrefix(warehouseData.CategoryOfWarehouse)+' '+warehouseData.Number;
        // (Nikita 2026-07-18) NO auto-jump on pick — the shopper confirms with the
        // sheet's Готово button; digx-cart.js routes that press to checkout when a
        // point is picked. Here: persist the attrs + let the drawer refresh its
        // gating/summary so Готово is ready the moment they press it.
        updateCartDeliveryAttr(properties).then(function () {
          if (window.DigxCart && window.DigxCart.refresh) return window.DigxCart.refresh();
        }).catch(npSilent);
      });

      // type-to-search (server-side)
      inputWarehouse.addEventListener("keyup", function(event){
        if (event.key == 'ArrowLeft' || event.key == 'ArrowRight') return;
        clearWarehouse.classList.remove('d-none');
        let searchField = this.value;
        var seq = ++warehouseSeq;
        if (searchField === '') {
          // cleared the field -> instantly restore the cached browse list (if any)
          var browseCached = warehouseCache[warehouseCityRef + '|'];
          clearList(filter);
          if (browseCached) renderWarehouses(filter, browseCached);
          return;
        }
        npGateCheckout();
        clearTimeout(warehouseTimer);
        warehouseTimer = setTimeout(function(){
          warehouseFetch(warehouseCityRef, searchField, function(){ return seq !== warehouseSeq; })
            .then(function(data){
              if (seq !== warehouseSeq) return;          // a newer keystroke owns the list
              renderWarehouses(filter, data);
            }).catch(npSilent);
        }, 200);
      });
    }
    /*== search street  ==*/
    function searchStreet(city) {  
      wrapAddresses.classList.remove('d-none');
      dataStreet = false;
      let streetPref;
      let output_prev = 0;
      inputStreet.addEventListener("keyup", function(event){
        if(event.key != 'ArrowLeft' && event.key != 'ArrowRight') {
          clearStreet.classList.remove('d-none');
          var filter = document.querySelector('#street_filter');  
          var searchField = this.value;
          if(searchField === '' || searchField.includes('&#8291;') || searchField === ' ')  {
            clearList(filter); clearStreet.classList.add('d-none'); streetErrorEl.innerHTML = ''; return;
          }
          if(searchField.includes(streetPref))  {          
            this.value = searchField.split(streetPref)[1];
          }  
        
          
          reqAPI({"apiKey": apiKey,"modelName": "AddressGeneral","calledMethod": "getStreet","methodProperties": {"CityRef" : city,"FindByString" : this.value,"Page" : "1","Limit" : "150"}})
            .then(function(res) {/*console.log(res.data);*/dataStreet = res.data;})
              .catch(function() {clearList(filter); streetErrorEl.innerHTML = alertKeyboard }); 
          
          var output = '';
          var count = 1;
            
          setTimeout( function() {
            dataStreet.forEach(function(val){ 		  
                output += '<a data-ref="'+val.Ref+'" data-street="'+ val.StreetsType + val.Description +'" data-prefix="'+val.StreetsType+'" class="street-link" href="javascript:void(0)" style="display:block;">' + val.StreetsType + val.Description + '</a>';
                count++;
            });

            if(dataStreet.length > 0 ) {clearList(filter); streetErrorEl.innerHTML = '';} else { if(output_prev > 0) streetErrorEl.innerHTML = alertStreet};
            filter.insertAdjacentHTML('afterbegin',output);

            let streetLinks = document.querySelectorAll('a.street-link');
            if(streetLinks.length > 0) {
              document.getElementById('street_filter').classList.add('active');
            }   
            streetLinks.forEach(function(street){
              street.addEventListener("click", function(el){
                addressStreet = this.getAttribute('data-street');
                inputStreet.value=this.getAttribute('data-street');
                streetPref = this.getAttribute('data-prefix');
                addressZip ='12345';
                clearList(filter);
                streetErrorEl.innerHTML = '';   // a valid street was chosen → drop any "Обери вулицю" error
                properties._delivery_courier_address    = addressStreet;
                properties._delivery_street             = addressStreet;
                properties._delivery_street_Ref         = this.getAttribute('data-ref');

              updateCartDeliveryAttr(properties).then(function(cart) {/*console.log(cart)*/}).catch(npSilent);

                checkoutButton.classList.remove('disabled');
                checkoutButtonWrapper.classList.remove('tool');
                checkoutButton.disabled = false;
                return;
              });
            })
          output_prev = output.length ;        
          },500);
        }
      });

      inputStreet.addEventListener("focusout", function(){
        if(this.value || this.value != '') {
          streetErrorEl.innerHTML = '';   // a filled street field must not keep showing the "choose from list" error
          addressStreet = 'вул.'+this.value;
          properties._delivery_courier_address  = addressStreet;
          properties._delivery_street           = addressStreet;
          updateCartDeliveryAttr(properties).then(function(cart) {/*console.log(cart)*/}).catch(npSilent);
        }
      })
    }
    /*== input build  ==*/
    inputBuild.addEventListener("keyup", function(){
      addressBuild = ', буд.'+this.value;
    })
    inputBuild.addEventListener("focusout", function(){
      addressStreet = addressStreet+''+addressBuild;
      properties._delivery_courier_address = addressStreet;
      properties._delivery_house           = addressBuild;
      updateCartDeliveryAttr(properties).then(function(cart) {/*console.log(cart)*/}).catch(npSilent);
    });
    /*== input flat  ==*/
    inputFlat.addEventListener("keyup", function(){
      addressFlat = ', кв.'+this.value;
    })
    inputFlat.addEventListener("focusout", function(){
      addressStreet = addressStreet+''+addressFlat;
      properties._delivery_courier_address = addressStreet;
      properties._delivery_flat            = addressFlat;
    updateCartDeliveryAttr(properties).then(function(cart) {/*console.log(cart)*/}).catch(npSilent);
    });
    function addErrorMessage() {
      const errorContainer = document.querySelector('.cart-terms .alert-danger');
        
        if (!errorContainer) return false;
      
        if (errorContainer && !(errorContainer.getAttribute('added-text'))) {
            // `translations` is a theme global that not every template defines. An UNDECLARED
            // identifier throws even through `?.`, and the throw happened inside a 100ms
            // interval whose clear line then never ran: a ReferenceError ten times a second
            // for the life of the page (seen in the console on every product page).
            var shippingTitle = (typeof translations !== 'undefined' && translations && translations.shipping_method)
              ? (translations.shipping_method.title || '') : '';
            if (shippingTitle) errorContainer.innerHTML += ' ' + shippingTitle;

          errorContainer.setAttribute('added-text', 'true');
          
          return true;
        }
    }
    var errorTries = 0;
    const errorInterval = setInterval(() => {
      const isSet = addErrorMessage();
      // give up after 10s — on templates that never render the terms error (every product
      // page) this poll used to keep firing for the whole life of the page
      if (isSet !== false || ++errorTries > 100) clearInterval(errorInterval);
    }, 100);
    // DigX fix (Roman 2026-07-27): "кнопка Оформити замовлення неактивна, не переходить
    // ні до чекауту ні до адресної форми" after coming back from the checkout.
    // ROOT CAUSE: `warehouseData` only exists once the shopper clicks a warehouse link in
    // THIS page's lifetime. Returning from the checkout is a fresh page load — the delivery
    // is restored from the cart attributes, but `warehouseData` stays undefined, so
    // `warehouseData.CategoryOfWarehouse` threw a TypeError. The handler had already run
    // `classList.add('disabled') + disabled = true` two lines earlier, so the throw left the
    // CTA permanently dead and no navigation ever happened.
    // FIX: (1) build address1 from the persisted cart attributes when the live NP objects are
    // absent, (2) never park the button in a dead state — a `busy` latch replaces the
    // disable-then-hope, and every failure path releases it.
    var checkoutLatch = npCheckoutLatch(checkoutButton);
    // "Відділення:1" (persisted) -> "Відділення 1" (the shape pointPrefix()+' '+Number gives)
    function savedWarehouseLabel() {
      var nm = properties._delivery_warehouse_name;
      if (nm) return String(nm).replace(/\s*:\s*/, ' ');
      var num = properties._delivery_warehouse_Number;
      return num ? (titleDelivery + ' ' + num) : (properties._delivery_warehouse || '');
    }
    checkoutButton.addEventListener('click', async function(e) {
      e.preventDefault();
      if (!checkoutLatch.acquire()) return;

      var address;
      try {
        addressCity = properties._delivery_city || addressCity || '';
        addressZip = '12345';
        var line1;
        if (deliveryType == 'branch') {
          line1 = warehouseData
            ? pointPrefix(warehouseData.CategoryOfWarehouse) + ' ' + warehouseData.Number
            : savedWarehouseLabel();
        } else {
          var street = addressStreet || properties._delivery_courier_address || properties._delivery_street || '';
          line1 = street + ' (' + methodCourier + ')';
        }
        address = { address1: line1, zip: addressZip, city: addressCity, country: country };
      } catch (err) {
        npSilent(err);
        checkoutLatch.release();
        return;
      }

      setTimeout(function () {
        fetch(`${cartUrl}.json`).then(response => response.json()).then(data => {
          const pairs = [];

          const path = data.items.map(item => {
            return `${item.variant_id}:${item.quantity}`;
          }).join(',');

          for (var key in properties) {
            const value = properties[key];

            if (!value) continue;

            const pair = `attributes[${key}]=${properties[key]}`;

            pairs.push(pair);
          }

          for (var key in address) {
            const value = address[key];

            if (!value) continue;

            const pair = `checkout[shipping_address][${key}]=${address[key]}`;

            pairs.push(pair);
          }

          let query;
          let url;
          if (data.note && data.note != null) {
          query = pairs.join('&') + `&note=${data.note}`;
          url = `${cartUrl}/${path}?${query}`;
          } else {
          query = pairs.join('&');
          url = `${cartUrl}/${path}?${query}`;
          }
          window.location.href = url;

        }).catch(function (err) {
          // never strand the shopper on a dead CTA — release it and fall back to the plain cart
          npSilent(err);
          checkoutLatch.release();
          window.location.href = cartUrl;
        });
      },200);

    });
    searchCity();
  } else {
    errorAPI();
  }
})
.catch(err => {  
  errorAPI();  
})

}

